/* File: is-mobile.jsx
 * Path: ananunadm/src/helpers/is-mobile.jsx
*/
import { useContext, createContext, useEffect, useState } from "react";

export const BREAKPOINTS = Object.freeze({
	xs: 480,
	sm: 576,
	md: 768,
	lg: 1024,
	xl: 1280
});

/** Mobile: <768px, tablet: 768–1023px, desktop: ≥1024px */
function computeResponsive(width) {
	return {
		width,
		isMobile: width < BREAKPOINTS.md,
		isTablet: width >= BREAKPOINTS.md && width < BREAKPOINTS.lg,
		isDesktop: width >= BREAKPOINTS.lg,
		isSmall: width < BREAKPOINTS.sm
	};
}

const defaultResponsive = computeResponsive(
	typeof window !== "undefined" ? window.innerWidth : 1280
);

export const IsMobile = createContext(defaultResponsive);

/** @returns {{ isMobile: boolean, isTablet: boolean, isDesktop: boolean }} */
export function useResponsive() {
	return useContext(IsMobile);
}

/** @returns {boolean} */
export function useMobile() {
	return useContext(IsMobile).isMobile;
}

export function IsMobileProvider({ children }) {
	const [responsive, setResponsive] = useState(() =>
		computeResponsive(typeof window !== "undefined" ? window.innerWidth : 1280)
	);

	useEffect(() => {
		const handleResize = () => {
			setResponsive(computeResponsive(window.innerWidth));
		};

		window.addEventListener("resize", handleResize);
		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	return <IsMobile.Provider value={responsive}>{children}</IsMobile.Provider>;
}
